<template>
    <!-- 
        Шапка розділу
        - objSection - 
        - - title - назва розділу
        - - desc - опис розділу
        - - checkBeta - бейдж на бету
        - - checkNew - бейдж на new
    -->
    <headerSection 
        :objSection="objSection"
    />

    <!-- 
        Фільтри
    -->
    <filterSection 
        v-if="objFilter.defaultType === 0"
        :objFilter="objFilter"
        :objPages="objPages"
        @changeTab="changeMode"
        @changelimit="changelimit"
        @getdata="getData"
    />

    <!-- Картки відгуків -->
    <template
        v-if="this.reviews.length > 0 && objFilter.defaultType === 0"
    >
        <div style="display: flex; gap: 20px; flex-wrap: wrap;margin-top: 15px;">
            <ReviewCard
                v-for="item in reviews"
                :obj="item"
                @showCommentWindow="fillForm"
                @openClientCard="openClientCard"
            />
        </div>
    </template>

    <!-- Таблиця з відгуками -->
    <tablecustom
        v-if="objFilter.defaultType === 1"
        :rows="rows"
        :columns="columns"
        :objParams="objParams"
        :showpag="showpag"
        :pages="pages"
        @open="open"
        @changelimit="changelimit"
        :objFilter="objFilter"
        @changeTab="changeMode"
        @getdata="getData"
    />

    <dialogModal 
        v-if="this.showCommentWindow === true" 
        @close="this.showCommentWindow = false"
    >
        <template v-slot:title>
            {{ $t('Comment') }}
        </template>
        <template v-slot:body>
            <div class="mb-3">
                <label for="exampleFormControlTextarea1" class="form-label">{{ $t("Comment") }}</label>
                <textarea 
                    class="form-control" 
                    id="exampleFormControlTextarea1" 
                    rows="4"
                    v-model="this.applicForm.comment"
                />
            </div>
        </template>
        <template v-slot:footer-bottom>
            <button class="btn btn-success" @click="addRequest">
                {{ $t("Add") }}
            </button>
        </template>
    </dialogModal>
</template>

<script>
import headerSection from '@/components/headerSection/headerSection.vue';
import filterSection from '@/components/headerSection/filterSection.vue';
import ReviewCard from './components/reviewCard.vue';
import dialogModal from "@/components/modal/dialog.vue"
import tablecustom from '@/components/globaltable/index.vue'
import { mutateReviewsGroups } from '@/usabilityScripts/globalMutate.js'
import { Reviews } from '../../../API_Dash';
import { Applications } from '../../../API';

let apiServe = new Reviews()
let apiApplic = new Applications()

export default {
    data() {
        return {
            reviews: [],
            showCommentWindow: false,
            applicForm: {
                userPhone: "",
                comment: "",
                status: "new",
                priority: 2
            },
            objParams: {
                page: '1',
                pagelimit: '10',
                whenceFilter: ""
            },
            objSection: {
                id: "",
                title: "",
                desc: "Відгуки по розділу",
                checkBeta: false,
                checkNew: false,
            },
            objFilter: {
                defaultType: 1, // grid
                checkChangeTab: true, // чи відображати можливість перемикання відображення (картки, таблиця)
                checkSearch: true, // статус відображення пошуку
                checkChangeLimit: true, // статус відображення зміни ліміту
                checkAddBtn: false, // статус відображення кнопки "додати"
                checkMoreFilter: false, // статус відображення кнопки більше фільтрів
            },
            objPages: '',
            pages: {},
            rows: [],
            columns: [
                {
                    name: this.$t("date_time"),
                    text: "datetime",
                    align: "left",
                    status: true,
                    copy: true,
                    mutate: (item, obj) => {
                        const date = new Date(obj.datetime); // перетворюємо строку в дату
                        return date.toLocaleDateString('uk-UA', { // форматуємо її
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric'
                        });
                    }
                },
                {
                    name: this.$t("SearchClientsNumphone"),
                    text: "companyId",
                    align: "left",
                    status: true,
                    copy: true,
                    mutate: (item, obj) => obj.user && obj.user.userPhone != false ? obj.user.userPhone : obj.companyId
                },
                {
                    name: this.$t("Оцінка"),
                    text: "rating",
                    align: "left",
                    status: true,
                    copy: true,
                    mutate: (item, obj) => {
                        const rating = obj.rating; // отримуємо рейтинг для поточного елементу
                        const color = this.getColorOfRating(rating); // визначаємо колір для рейтингу

                        return `<div style="display:flex;gap:5px"><i class="ri-star-fill" style="${color}"></i>${rating}</div>`
                        //return `<span style="${color}">${rating}</span>`; // повертаємо HTML зі зірками і кольором
                    }
                },
                {
                    name: this.$t("Comment"),
                    text: "comment",
                    align: "left",
                    status: true,
                    copy: true,
                },
            ],
            showpag: true
        }
    },
    components: {
        headerSection,
        filterSection,
        ReviewCard,
        dialogModal,
        tablecustom
    },
    created() {

        if (this.$route.params.id) {
            this.objSection.id = this.$route.params.id
            this.objSection.title = this.mutateReviewsGroup(this.$route.params.id).name
            this.objParams.whenceFilter = JSON.stringify([this.$route.params.id]);
        }
        
        this.getData(this.objParams.page)
    },
    methods: {
        openClientCard(compId){
            this.eventBus.emit('getClient', {
                status: true,
                number: compId
            })
        },
        changeMode(mode) {
            this.objFilter.defaultType = mode
        },
        getColorOfRating(rating) {
            if(rating >= 4) {
                return 'color: #0ab39c'
            } else if(rating < 3) {
                return 'color: red'
            } else {
                return 'color: #ff9d00'
            }
        },
        fillForm(obj) {
            this.applicForm.userPhone = obj.user.userPhone
            this.applicForm.comment = 
`Створено з відгуку клієнта: ${obj.user.userPhone}. 
Відгук надійшов з компанії: ${obj.companyId}
Відгук: ${obj.comment}`
            this.showCommentWindow = true
        },
        getData(page) {
            console.log("getdata")

            this.objParams.page = page != undefined ? page : '1';

            // apiServe.getReviews({page: '1', pagelimit: '10'}, [this.$route.params.id]).then(result => {
            apiServe.getReviews(this.objParams).then(result => {
                if(result.status === 'done') {
                    this.reviews = result.data.reviews
                    this.rows = result.data.reviews
                    this.objPages = result.data;
                    this.pages = result.data
                }
            })
        },
        addRequest() {
            apiApplic.addRequest(this.applicForm).then(result => {
                if(result.status === 'done') {
                    this.applicForm.userPhone = "";
                    this.applicForm.comment = "";
                    this.showCommentWindow = false;
                }
            })
        },
        // змінити ліміт і оновити дані
        changelimit: function(limit){
            this.objParams.pagelimit = limit;
            this.getData();
        },
        mutateReviewsGroup(item, obj) {
            return mutateReviewsGroups(item)
        },
    }
}

</script>